import { useEffect } from "react";
import { useLocation } from 'react-router-dom';



const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
const location = useLocation();


useEffect(() => {
  if (!token) {
    alert("You must be logged in to access this page.");
    window.location.href = window.location.origin;
  }
}, [token]);




  if (!token) {
    // Show nothing because redirect is handled inside useEffect
    return null;
  }

  return children;
};

export default PrivateRoute;
